exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-content{margin-top:112px;min-height:550px}.baby-club .main-content,.privacy .main-content{margin-top:65px}body.no-scroll{overflow:hidden}@media (min-width:768px){.baby-club .main-content,.privacy .main-content{margin-top:121px}}@media (min-width:961px){.wrapper{max-width:1024px}.main-content{margin-top:121px}.menu-overlay{display:none}}@media (min-width:1201px){.wrapper{max-width:1150px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/main-content/main-content.scss
// module id = 903
// module chunks = 0